import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "../../redux-store";
import { useTypedTranslations } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formContainer: {
      padding: "5% 10%",
    },
    formTitle: {
      fontWeight: "bold",
      fontSize: "25px",
      marginBottom: "0.4em",
    },
    inputField: {
      margin: "5px 0 !important",
    },
    member: {
      textAlign: "center",
      marginTop: "1em",
      fontSize: "12px",
    },
  }),
);

const fields = [
  {
    name: "email",
    type: "text",
    label: "Email",
  },
  {
    name: "password",
    type: "password",
    label: "Password",
  },
];

const useLoginForm = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const { register, handleSubmit } = useForm<{
    email: string;
    password: string;
  }>();
  const dispatch = useDispatch();
  const [t] = useTypedTranslations();
  const isSigningIn = useSelector(
    selectors.getAjaxIsLoadingByApi(actions.getUsersMe.api),
  );

  const onSubmit = useMemo(
    () =>
      handleSubmit((signInData) => {
        dispatch(actions.cognitoSignIn(signInData));
      }),
    [handleSubmit, dispatch],
  );

  return {
    styles,
    classes,
    atomicStyles,
    register,
    handleSubmit,
    onSubmit,
    fields,
    t,
    isSigningIn,
  };
};

export { useLoginForm as default };
